/* Shop the look — filteren op tags (meerdere tegelijk, OR-logica) */
(function () {
  function getSelectedTags(filterBar) {
    return Array.from(filterBar.querySelectorAll('[data-stl-filter-checkbox]:checked')).map(function (cb) {
      return cb.value;
    });
  }

  function applyFilters(root, filterBar) {
    var selected = getSelectedTags(filterBar);
    var items = root.querySelectorAll('.stl-item');
    var visibleCount = 0;

    items.forEach(function (item) {
      var show = true;
      if (selected.length > 0) {
        var itemTags = (item.getAttribute('data-stl-tags') || '').split('|').filter(Boolean);
        show = selected.some(function (tag) {
          return itemTags.indexOf(tag) !== -1;
        });
      }
      item.classList.toggle('is-filtered-out', !show);
      if (show) visibleCount++;
    });

    var emptyMsg = root.querySelector('[data-stl-empty]');
    if (emptyMsg) emptyMsg.classList.toggle('is-visible', visibleCount === 0);

    filterBar.querySelectorAll('.stl-filter-pill').forEach(function (pill) {
      var checkbox = pill.querySelector('[data-stl-filter-checkbox]');
      pill.classList.toggle('is-checked', !!(checkbox && checkbox.checked));
    });
  }

  function initFilterBar(filterBar) {
    var root = filterBar.closest('[data-stl-root]') || filterBar.parentElement;

    filterBar.addEventListener('change', function (event) {
      if (event.target.matches('[data-stl-filter-checkbox]')) {
        applyFilters(root, filterBar);
      }
    });

    var resetBtn = filterBar.querySelector('[data-stl-filter-reset]');
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        filterBar.querySelectorAll('[data-stl-filter-checkbox]').forEach(function (cb) {
          cb.checked = false;
        });
        applyFilters(root, filterBar);
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-stl-filters]').forEach(initFilterBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
